import { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

interface TranslateProps {
    text: string
    className?: string
}

const Translate = (props: TranslateProps) => {
  const { t } = useTranslation();
  const { text, className } = props;

  if(className)
  return <span className={className}>{t(text)}</span>
  else return <Fragment>{t(text)}</Fragment>
}

export default Translate;